module.exports = __webpack_public_path__ + "img/code3.e39a74fc.png";